import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hidden" }
const _hoisted_2 = { class: "h-full w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  id: "end-of-doc",
  style: {"z-index":"2"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_fleet_popover = _resolveComponent("fleet-popover")!
  const _component_toaster = _resolveComponent("toaster")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.isConnected()), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view),
      (_openBlock(), _createBlock(_Teleport, { to: "#end-of-body" }, [
        (_ctx.$route.query.popover ==='subscription_popover' )
          ? (_openBlock(), _createBlock(_component_fleet_popover, { key: 0 }))
          : _createCommentVNode("", true)
      ])),
      _hoisted_3,
      _createVNode(_component_toaster)
    ])
  ], 64))
}